module.exports = __webpack_public_path__ + "img/Feature.f014fe85.jpg";